import React from "react";
import { Box } from "@mui/material";
import bannerImage from "../assets/images/cover.jpg"; // Importing the image from assets

interface BannerProps {
  children: React.ReactNode;
}

const Banner: React.FC<BannerProps> = ({ children }) => {
  return (
    <Box
      sx={{
        backgroundImage: `url(${bannerImage})`, // Using the imported image
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        position: "relative",
        zIndex: 1,
        pt:{xs:"0", md:"5rem"},
        pb:{xs:"0", md:"3rem"},
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.4)", // Optional overlay
          zIndex: -1,
        }}
      />
      {children}
    </Box>
  );
};

export default Banner;
